import { SELECTOR_COMBINATORS } from '../common.mjs';

const prefixMap = {
    'class': '.',
    'pseudo-class': ':',
    'pseudo-element': '::',
    'attribute': '',
    'combinator': '',
    'id': '#'
};
function generateSelector(nodes, body = '') {
    const generate = (node)=>{
        if (node.type === 'attribute') return `[${node.value}]`;
        if (node.type === 'combinator') return node.value;
        const prefix = node.type && prefixMap[node.type] || '';
        const base = node.value ? prefix + node.value : '';
        if ('children' in node && node.children?.length) {
            const childrenText = node.children.map(generate).join('');
            return node.value ? base + `(${childrenText})` : base + childrenText;
        }
        return base;
    };
    let pre = '';
    let current = '';
    const groups = [];
    const flatNodes = nodes.flatMap((node)=>!('value' in node) && 'children' in node && node.children?.length ? node.children : node);
    flatNodes.forEach((node)=>{
        if (node.value === ',') {
            groups.push(current);
            current = '';
        } else if (node.value === 'of' && 'children' in node) {
            pre += node.children.map(generate).join('');
        } else {
            current += generate(node);
        }
    });
    if (current) groups.push(current);
    if (pre) {
        const lastChar = pre.charAt(pre.length - 1);
        if (!SELECTOR_COMBINATORS.includes(lastChar) && lastChar !== ' ') {
            pre += ' ';
        }
    }
    const result = groups.length ? groups.map((text)=>pre + body + text).join(',') : pre + body;
    return result;
}

export { generateSelector as default };
